module.exports = __webpack_public_path__ + "img/icon-light-clock.51d561e0.svg";